export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  { text: 'SDT', align: 'start', value: 'phoneNumber', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'phoneNumber')?.value) return true
        return value.includes(filters.find(x=>x.name === 'phoneNumber')?.value)
      }
  },
  { text: 'User', align: 'start', value: 'userName', width: '10rem',  
      filter: value => true
  },
  
  { text: 'Ngày', align: 'start', value: 'createdAt', width: '10rem',  
      filter: value => true
  },

  { text: 'IP Check-in', align: 'start', value: 'checkInIp',
      filter: value => true
  },
  
  { text: 'Nơi check-in', align: 'start', value: 'checkInPlace',
      filter: value => true
  },
  
  { text: 'IP Check-out', align: 'start', value: 'checkOutIp',
      filter: value => true
  },
  
  { text: 'Nơi check-out', align: 'start', value: 'checkOutPlace',
      filter: value => true
  },

// CheckInIp
// CheckInPlace
// CheckOutIp
// CheckOutPlace
// CreatedAt
// Review
// CheckInTime
// CheckOutTime
// CheckInStoreCode
// CheckOutStoreCode
// CheckInAddress
// CheckInLong
// CheckInLat
// CheckOutAddress
// CheckOutLong
// CheckOutLat

]